import { memo } from 'react'
import { GrSort, GrTasks } from 'react-icons/gr'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { DownloadPopover } from './download-popover'

type FeedButtonProps = {
  domain: string
  pageCount: number
  grouped?: boolean
  onHeadingToggleEvent(): any
  onSortClick(): any
  onGroupClick(): any
  onCSVClick?(): void
  onJsonClick?(): void
}

const feedColor = 'p-4 text-left hover:opacity-70'

const FeedButtonWrapper = ({
  domain,
  pageCount,
  grouped,
  onHeadingToggleEvent,
  onSortClick,
  onGroupClick,
  onCSVClick,
  onJsonClick,
  translation,
}: FeedButtonProps & { translation?: string }) => {
  const { t } = useTranslation(translation || 'dashboard')

  const sortTitle = `${t('sort')} ${domain} ${t('pages').toLowerCase()}`
  const groupTitle = `${t('view-priorities')} ${domain}`
  const csvTitle = `${t('csv')} ${domain}`
  const jsonTitle = `JSON ${domain}`
  const pageText = `${t(pageCount === 1 ? 'page' : 'pages')}: ${pageCount}`

  return (
    <div className='flex place-items-center'>
      <button
        className='p-4 text-lg w-full ltr:text-left rtl:text-right font-medium hover:text-indigo-600'
        onClick={onHeadingToggleEvent}
        type={'button'}
      >
        <div>
          {domain}
          <div className='text-xs font-normal uppercase'>{pageText}</div>
        </div>
      </button>
      <DownloadPopover
        className={classNames(
          feedColor,
          'hover:text-green-700 dark:hover:text-green-400'
        )}
        onCSVClick={onCSVClick}
        onJsonClick={onJsonClick}
        jsonTitle={jsonTitle}
        csvTitle={csvTitle}
      />
      <button
        className={classNames(
          feedColor,
          grouped ? 'text-blue-800' : '',
          'hover:text-blue-700 dark:hover:text-blue-400'
        )}
        onClick={onGroupClick}
        title={groupTitle}
        type={'button'}
      >
        <>
          <span className='sr-only'>{groupTitle}</span>
          <GrTasks className='grIcon' />
        </>
      </button>
      <button
        className={classNames(
          feedColor,
          'hover:text-indigo-700 dark:hover:text-indigo-400'
        )}
        onClick={onSortClick}
        title={sortTitle}
        type={'button'}
      >
        <>
          <span className='sr-only'>{sortTitle}</span>
          <GrSort className='grIcon' />
        </>
      </button>
    </div>
  )
}

export const FeedButton = memo(FeedButtonWrapper)
